import { ValidatedField } from "./ValidatedField";
import { PLACEHOLDERS, normalizeUstIdNr, validateUstIdNr } from "../validation";

/** USt-IdNr-Feld: "DE" + 9 Ziffern; 9 nackte Ziffern bekommen "DE" beim Blur. */
export function UstIdNrInput({
  label,
  name,
  value,
  onChange,
  required,
}: {
  label: string;
  name: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
}) {
  return (
    <ValidatedField
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      placeholder={PLACEHOLDERS.ustIdNr}
      sanitize={(v) => v.toUpperCase().replace(/[^A-Z0-9]/g, "")}
      normalizeOnBlur={normalizeUstIdNr}
      validate={validateUstIdNr}
    />
  );
}

export default UstIdNrInput;
